import styled from 'styled-components';

import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import FormContainer from "../../../components/form_container";
import useFeedback from "../../../utils/use_feedback";
import {useSubscriptionStatus} from "../../../api/payments";
import {Button} from "@chakra-ui/react";
import useModal from "../../../modals";
import React, {useState} from "react";
import Sheet from "../../../components/bottom-sheet/sheet";
import CancelProSheet from "../../../components/bottom-sheet/pro/cancel_pro";
import IncreasePriceSheet from "../../../components/bottom-sheet/pro/increase_price";

const CategoryHeading = styled.div``;
const Buttons = styled.div``;

const SubscriptionSettings = styled(({className}) => {

    const {error, feedbackCh} = useFeedback();
    const subscription = useSubscriptionStatus(feedbackCh);

    const modal = useModal();

    const [cancelOpen, setCancelOpen] = useState(false);
    const [increaseOpen, setIncreaseOpen] = useState(false);

    const handleCancel = () => {
        setCancelOpen(true);
    };

    const handleIncreasePrice = () => {
        setIncreaseOpen(true);
    };

    const handleRenew = () => {
         modal.open('PayWithCrypto', {renew: true});
    };

    return (
        <>
            <FixedTopBar back title="Subscriptions" border={false}/>
            <WhiteMain className={className}>
                <FormContainer>

                    {error &&
                        <p>You do not have an active paid subscription.</p>
                    }

                    {subscription &&
                    <>
                        <CategoryHeading>
                            <h2>Monthly Cost</h2>
                        </CategoryHeading>
                        <p>{subscription.price}</p>
                        <CategoryHeading>
                            <h2>Payment Method</h2>
                            <p>
                                {subscription.source === "card" ? "Credit / Debit Card" : "Cryptocurrency"}
                            </p>
                        </CategoryHeading>
                        <CategoryHeading>
                            <h2>Renewal Date</h2>
                        </CategoryHeading>
                        <p>{new Date(subscription.expiryDate).toLocaleDateString()}</p>
                        {subscription.userCancelled ?
                            <p style={{marginTop: 8, fontSize: 15}}>This subscription will cancel on the renewal date.</p>
                            :
                            <Buttons>
                                <Button variant='grey' mt='6px' mr='8px' onClick={() => subscription.source === "card" ? handleCancel() : handleRenew()}>
                                    {subscription.source === "card" ? "Cancel" : "Renew"}
                                </Button>
                                <Button variant='blue' mt='6px'
                                        onClick={() => handleIncreasePrice()}>
                                    Edit Price
                                </Button>
                            </Buttons>
                        }

                    </>
                    }

                </FormContainer>
            </WhiteMain>
            {cancelOpen && <Sheet onClose={() => setCancelOpen(false) } padding={"header"}><CancelProSheet onClose={() => setCancelOpen(false) } /></Sheet>}
            {increaseOpen && <Sheet onClose={() => setIncreaseOpen(false) } padding={"header"}><IncreasePriceSheet currentPrice={subscription.price} onClose={() => setIncreaseOpen(false) } /></Sheet>}
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
  ${CategoryHeading} {
    margin-top: 12px;
  }
  ${CategoryHeading}:first-of-type {
    margin-top: 0;
  }
  p {
    margin-bottom: 16px;
  }
`;

export default SubscriptionSettings;
